import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./VideoList.scss";
import {
  fetchContentPublications,
  updateStatut
} from '../services/apiContent';
import { BASE_URL } from "../services/constant";

const VideoList = () => {
  const [search, setSearch] = useState("");
  const [videos, setVideos] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const [currentTab, setCurrentTab] = useState(1); // 1 = non publié, 2 = publié
  const [savingIds, setSavingIds] = useState({});

  const rowsPerPage = 10;

  
  const navigate = useNavigate();
  
  // Données fictives de test (à remplacer par ton API)
  useEffect(() => {
    async function load() {
      try {
        const data = await fetchContentPublications(currentTab); 
        //console.log(data);
        setVideos(data);
      } catch (err) {
        console.error(err);
      }
    }
  
    load();
  }, [currentTab]);
  

  useEffect(() => {
    setFiltered(
      videos.filter((v) =>
        v.title.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, videos]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const displayed = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  // Limiter la description
function limitText(text, max = 250) {
  if (!text) return "";
  return text.length > max ? text.substring(0, max) + "..." : text;
}

// Convertir durée (secondes → HH:MM:SS)
function formatDuration(seconds) {
  if (!seconds || isNaN(seconds)) return "00:00";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  // si 0 heure : n'afficher que mm:ss
  if (h === 0) {
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(
    s
  ).padStart(2, "0")}`;
}
function formatNumber(num) {
  if (num < 10000) {
    return num.toString();
  }

  if (num < 1000000) {
    const value = (num / 1000).toFixed(1);
    return value.endsWith('.0') ? `${parseInt(value)}k` : `${value}k`;
  }

  const value = (num / 1000000).toFixed(1);
  return value.endsWith('.0') ? `${parseInt(value)}M` : `${value}M`;
}



// Formater date MySQL → "26 Aug 2022"
function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const publishVideo = async (id, newStatut) => {
  try {
    setSavingIds(s => ({ ...s, [id]: true }));

    const res = await updateStatut({ id, statutpub: newStatut });

    if (!res) throw new Error("Aucune réponse du serveur");
    if (!res.ok) throw new Error("Erreur serveur");

    setVideos(prev => {
      if ((currentTab === 1 && newStatut === 2) || (currentTab === 2 && newStatut === 1)) {
        return prev.filter(v => v.id !== id);
      }
      return prev.map(v => v.id === id ? { ...v, statutpub: newStatut } : v);
    });

    alert("Opération réussie !");
  } catch (err) {
    console.error(err);
    alert("Erreur lors de la mise à jour du statut");
  } finally {
    setSavingIds(s => {
      const copy = { ...s };
      delete copy[id];
      return copy;
    });
  }
};




  return (
    
    <div className="page-content">
    <div className="video-list-container">
      <h2 className="page-title">Publications contenus</h2>

      {/* Tabs */}
      <div className="tabs">
        <button
          className={`tab ${currentTab === 1 ? "active" : ""}`}
          onClick={() => setCurrentTab(1)}
        >
          Videos non publiés
        </button>

        <button
          className={`tab ${currentTab === 2 ? "active" : ""}`}
          onClick={() => setCurrentTab(2)}
        >
          Videos publiés
        </button>
      </div>


      {/* Search / Filter */}
      <div className="filter-bar">
        <input
          type="text"
          placeholder="Filter videos..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <table className="video-table">
        <thead>
          <tr>
            <th></th>
            <th>Video</th>
            <th>Visibility</th>
            <th>Category</th>
            <th>Date</th>
            <th>Views</th>
            <th>Likes</th>
            <th>Dislikes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {displayed.map((video) => (
            <tr key={video.id}>
              <td>
                <input type="checkbox" />
              </td>
              <td className="video-cell">
                <div className="thumb">
                  <img src={`${BASE_URL}api/${video.image}`} alt={video.id} />
                  <span className="duration">{formatDuration(video.duration)}</span>
                </div>
                <div className="video-info" onClick={() => navigate(`/video/${video.id}`)}>
                  <strong>{video.title}</strong>
                  <p>{limitText(video.description, 50)}</p>
                  <p className="acteur">Acteur : { video.nom}</p>
                </div>
              </td>
              <td>Public</td>
              <td>{video.title_categorie}</td>
              <td>{formatDate(video.created_at)}</td>
              <td>{formatNumber(video.views)}</td>
              <td>{formatNumber(video.likes)}</td>
              <td>{formatNumber(video.dislikes)}</td>
              <td>
                <button
                  className={`pub-btn ${video.statutpub === 2 ? "published" : "unpublished"}`}
                  onClick={() =>
                    publishVideo(
                      video.id,
                      video.statutpub === 2 ? 1 : 2 // 👉 toggle du statut
                    )
                  }
                >
                  {video.statutpub === 2 ? "Rétirer" : "Publier"}
                </button>
                
              </td>

            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <span>
          Rows per page: <b>{rowsPerPage}</b>
        </span>
        <span>
          {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
          {filtered.length}
        </span>
        <button
          disabled={page === 1}
          onClick={() => handleChangePage(page - 1)}
        >
          ‹
        </button>
        <button
          disabled={page * rowsPerPage >= filtered.length}
          onClick={() => handleChangePage(page + 1)}
        >
          ›
        </button>
      </div>
    </div>

    </div>
  );
};

export default VideoList;
